<template>
  <div class="animated fadeIn">
    <b-row class="mb-3">
      <b-col md="2" class="pt-2">{{ formLabel }}</b-col>
      <b-col v-if="projectFormStepOne.customer_id">
        <b-input-group>
          <b-form-select
            v-model="selected_customer_field_id"
            :options="customer_field_options"
            :disabled="!currentSubmission.customer_grower_id"
          >
            <template slot="first">
              <option :value="null">
                Select Field
              </option>
            </template>
          </b-form-select>
        </b-input-group>
      </b-col>
      <b-col>
        <b-input-group>
          <b-form-input
            type="text"
            v-model="identifier"
            :placeholder="'Submission Name'"
            invalid-feedback="Required"
            :state="!$v.identifier.$invalid"
          />
        </b-input-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-form-group label="Event Code" :label-cols="2" :horizontal="true">
          <b-form-input
            type="text"
            v-model="event_code"
            :placeholder="'Submission Event Code (optional)'"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { validationMixin } from "vuelidate/src";
import { required } from "vuelidate/lib/validators";
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import CustomerFieldCollection from "@/collections/crm/CustomerFieldCollection";

export default {
  name: "ProjectFieldFormGroup",
  mixins: [validationMixin, ToastNotifications],
  props: {
    submissionId: {
      type: String,
      default: "",
    },
    formLabel: {
      type: String,
      default: "Project",
    },
  },
  data() {
    return {
      customer_fields: null,
      selected_customer_field_id: null,
    };
  },
  computed: {
    ...mapGetters({
      submission: "projectFormStepTwoSubmission",
      projectFormStepOne: "projectFormStepOne",
    }),
    currentSubmission() {
      return this.submission(this.submissionId);
    },
    identifier: {
      get() {
        return this.currentSubmission.identifier;
      },
      set(value) {
        this.UPDATE_SUBMISSION({
          id: this.submissionId,
          value,
          name: "identifier",
        });
      },
    },
    event_code: {
      get() {
        return this.currentSubmission.event_code;
      },
      set(value) {
        this.UPDATE_SUBMISSION({
          id: this.submissionId,
          value,
          name: "event_code",
        });
      },
    },
    customer_field_options () {
      return this.customer_fields && this.customer_fields.models && this.customer_fields.models.map((field) => {
        return {
          value: field.id,
          text: field.name
        }
      }) || []
    }
  },
  validations: {
    identifier: { required },
  },
  watch: {
    selected_customer_field_id (value) {
      if (value) {
        this.identifier = this.customer_fields.models.find((field) => field.id === value).name
      } else {
        this.identifier = null
      }
    },

    'currentSubmission.customer_grower_id' () {
      this.fetchCustomerField()
    }
  },
  mounted() {
    this.fetchCustomerField()
  },
  methods: {
    ...mapActions(["UPDATE_SUBMISSION"]),
    fetchCustomerField () {
      const collection = new CustomerFieldCollection()
      const filter = collection.getFilter()

      filter.filterEquals('customer.id', this.projectFormStepOne.customer_id)
      if (this.currentSubmission.customer_grower_id) {
        filter.filterEquals('customer_grower_id', this.currentSubmission.customer_grower_id)
      }

      collection.fetch().then(() => {
        this.customer_fields = collection
      })
    }
  },
};
</script>
